module.exports = __webpack_public_path__ + "ead587ce85ba34a4a9148a1fa6e51e18.svg";